import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
export const getSalesDataTxt = (start, provider, partClass) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/parts/japan-report-parts?startDate=${start}&provider=${provider}&type=${partClass}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_COMBOS_DATA_REPORT_TXT,
        ActionTypes.FETCHED_COMBOS_DATA_REPORT_TXT,
        [ActionTypes.FETCHED_COMBOS_DATA_REPORT_TXT_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};
